import { render, staticRenderFns } from "./WalletUpdatePassword.vue?vue&type=template&id=5f36730e&scoped=true&"
import script from "./WalletUpdatePassword.vue?vue&type=script&lang=js&"
export * from "./WalletUpdatePassword.vue?vue&type=script&lang=js&"
import style0 from "./WalletUpdatePassword.vue?vue&type=style&index=0&id=5f36730e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36730e",
  null
  
)

export default component.exports